/**
 * @generated SignedSource<<f95b1663df4fa46e2f26ba943dd05ea0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useCycleShopifyTokenMutation$variables = {
  brandId: string;
};
export type useCycleShopifyTokenMutation$data = {
  readonly cycleShopifyToken: {
    readonly accessTokenExpiresAt: any | null;
    readonly accessTokenLast4: string | null;
    readonly adminChangeUrl: string | null;
    readonly error: string;
    readonly refreshTokenExpiresAt: any | null;
    readonly refreshedAt: any | null;
    readonly state: string;
  };
};
export type useCycleShopifyTokenMutation = {
  response: useCycleShopifyTokenMutation$data;
  variables: useCycleShopifyTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      }
    ],
    "concreteType": "InternShopifyTokenStatus",
    "kind": "LinkedField",
    "name": "cycleShopifyToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessTokenLast4",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessTokenExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshTokenExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminChangeUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCycleShopifyTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCycleShopifyTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "17e6576260f778c3f4b7abf9337b00c5",
    "id": null,
    "metadata": {},
    "name": "useCycleShopifyTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useCycleShopifyTokenMutation(\n  $brandId: ID!\n) {\n  cycleShopifyToken(brandId: $brandId) {\n    state\n    accessTokenLast4\n    accessTokenExpiresAt\n    refreshTokenExpiresAt\n    refreshedAt\n    error\n    adminChangeUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "119650e89b1051878375fec71d602eb9";

export default node;
